import { Injectable } from '@angular/core';
import { RdsNativeDateAdapter } from '@rds/angular-components';

@Injectable()
export class CustomDateAdapter extends RdsNativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}

export function dateClass(d: Date) {
  const date = d.getDay();
  return date === 0 || date === 6 ? 'weekend' : 'weekday';
}
